import { put,takeLatest } from 'redux-saga/effects';

import MyFavoritesService from '../../../services/MyFavorites.service';
import { locateMyFavoritesIn } from '../../../utils/enumerator/MyFavorites';
import { locateIn } from '../../../utils/locate';
import {
  ERROR_GET_MY_FAVORITES,
  GET_MY_FAVORITES,
  SUCESS_GET_MY_FAVORITES} from '../../constants';

function* getMyFavorites(action) {
  try {
    const myFavorites = yield MyFavoritesService.get(action.params);
    yield put({
      type: SUCESS_GET_MY_FAVORITES,
      data: locateIn(myFavorites, locateMyFavoritesIn)
    });
  } catch (error) {
    yield put({ type: ERROR_GET_MY_FAVORITES, error });
  }
}

function* getMyFavoritesSagas() {
  yield takeLatest(GET_MY_FAVORITES, getMyFavorites);
}

export default getMyFavoritesSagas;
